module.exports = __webpack_public_path__ + "h5/img/hong-kong-business-registration.510cf9a2.webp";